export const POI_SPHERE_DIAMATER:number = 25.0;